import mlRiskScoreEndpoints from './endpoints/mlRiskScore.endpoints';

/**
 * Get the ML-calculated risk score for a subject.
 * @param {number} alienId - The alien/subject identifier.
 * @returns {Promise<Object|null>} The ML risk score with factor breakdown.
 */
export async function getMlRiskScore(alienId) {
  try {
    const response = await mlRiskScoreEndpoints.getScore(alienId);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log(`[getMlRiskScore] No ML risk score found for alien ${alienId}`);
      return null;
    }
    console.error('[getMlRiskScore] Error:', error);
    return null;
  }
}

/**
 * Get the ML risk score history for a subject.
 * @param {number} alienId - The alien/subject identifier.
 * @param {number} [limit=30] - Maximum number of records to return.
 * @returns {Promise<Object|null>} Historical ML risk scores.
 */
export async function getMlRiskScoreHistory(alienId, limit = 30) {
  try {
    const response = await mlRiskScoreEndpoints.getHistory(alienId, { params: { limit } });
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log(`[getMlRiskScoreHistory] No history found for alien ${alienId}`);
      return null;
    }
    console.error('[getMlRiskScoreHistory] Error:', error);
    return null;
  }
}

/**
 * Get SHAP-like factor explanation for the most recent ML risk score.
 * @param {number} alienId - The alien/subject identifier.
 * @returns {Promise<Object|null>} Detailed factor explanations and recommendations.
 */
export async function getRiskFactorExplanation(alienId) {
  try {
    const response = await mlRiskScoreEndpoints.getFactors(alienId);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log(`[getRiskFactorExplanation] No factors found for alien ${alienId}`);
      return null;
    }
    console.error('[getRiskFactorExplanation] Error:', error);
    return null;
  }
}
